var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_902_1702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.98999 13.98C5.60552 13.98 4.25215 13.5694 3.101 12.8003C1.94986 12.0311 1.05265 10.9379 0.522837 9.65877C-0.00697666 8.37968 -0.1456 6.97222 0.124496 5.61435C0.394593 4.25648 1.06128 3.0092 2.04025 2.03024C3.01921 1.05127 4.26649 0.384583 5.62436 0.114487C6.98223 -0.15561 8.38969 -0.0169865 9.66878 0.512827C10.9479 1.04264 12.0411 1.93985 12.8103 3.09099C13.5795 4.24214 13.99 5.59551 13.99 6.97998C13.99 7.89924 13.8089 8.80949 13.4572 9.65877C13.1054 10.508 12.5898 11.2797 11.9397 11.9297C11.2897 12.5797 10.5181 13.0954 9.66878 13.4471C8.8195 13.7989 7.90925 13.98 6.98999 13.98V13.98ZM6.98999 1.24998C5.85516 1.25196 4.74637 1.59029 3.80375 2.22221C2.86113 2.85413 2.12697 3.75128 1.69406 4.8003C1.26115 5.84932 1.1489 7.00313 1.37151 8.11592C1.59412 9.22871 2.14158 10.2505 2.94473 11.0523C3.74788 11.8541 4.77067 12.3997 5.88385 12.6204C6.99702 12.8411 8.15063 12.7268 9.1989 12.2921C10.2472 11.8573 11.143 11.1216 11.7733 10.1779C12.4036 9.23419 12.74 8.12482 12.74 6.98998C12.7373 5.46672 12.1304 4.00675 11.0523 2.93058C9.97428 1.85441 8.51326 1.24998 6.98999 1.24998V1.24998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0179 10.9992L11.134 11.8831L15.8999 16.649L16.7838 15.7651L12.0179 10.9992Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62012 3.46997H6.37012V10.52H7.62012V3.46997Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.52 6.37H3.46997V7.62H10.52V6.37Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89001 4.54998C10.2379 4.54998 10.52 4.26792 10.52 3.91998C10.52 3.57204 10.2379 3.28998 9.89001 3.28998C9.54207 3.28998 9.26001 3.57204 9.26001 3.91998C9.26001 4.26792 9.54207 4.54998 9.89001 4.54998Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_902_1702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.77,
    height: 16.64,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/Magnifier.fd55e211.svg";
export { ForwardRef as ReactComponent };